<template>
  <div
    class="title-button"
    :class="{borderTop:borderTop}"
  >
    <p
      v-if="title"
      class="title-button_title"
    >
      {{ title }}
    </p>
    <div class="title-button_tabs">
      <slot name="tabs" />
    </div>
    <div class="title-button_content">
      <slot name="button" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TitleButton",
  props: {
    title: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/title-button";
</style>